import SIMPLE_DATE_RANGE from "./simple-date-range";

const getStartDate = (rangeLabel: string) =>
  SIMPLE_DATE_RANGE.find(({ label }) => label === rangeLabel)?.getStartDate();

export default getStartDate;
